// Google Drive link helpers (mirror of backend logic)

const DRIVE_ID_PATTERNS = [
  /\/file\/d\/([a-zA-Z0-9_-]+)/,
  /[?&]id=([a-zA-Z0-9_-]+)/,
  /\/d\/([a-zA-Z0-9_-]+)/,
];

export function extractDriveId(url) {
  if (!url) return null;
  for (const p of DRIVE_ID_PATTERNS) {
    const m = url.match(p);
    if (m) return m[1];
  }
  return null;
}

export function toPreviewLink(url) {
  const id = extractDriveId(url);
  if (id) return `https://drive.google.com/file/d/${id}/preview`;
  return url;
}

export function buildIframeCode(embedLink, { width = "100%", height = 700 } = {}) {
  return `<iframe src="${embedLink}" width="${width}" height="${height}" allow="autoplay"></iframe>`;
}
